
import { RadioGroup, Radio } from "@nextui-org/react";
import StepLayout from "../../components/StepLayout";
import { SQFForm, SQFStepOf } from "../../hooks/useServiceQuoteFlow";
import { useStore } from "@tanstack/react-form";
import { isMobile } from "@/utils/is-mobile";
import { cn } from "@networx/utils/tailwind/cn";

export default function QuestionStep({ step, form, onClickPrev }: Props) {
  const questions = useStore(form.store, (state) => state.values.questions);
  const questionId = step.id;
  const index = questions.findIndex(q => q.questionId === questionId);
  if (index === -1) {
    throw new Error(`Hmmm... we trying to render a question not in the form '${questionId}'`);
  }
  const isMobileView = isMobile();

  if (step?.hidden) return null;
  return (
    <StepLayout
      title={step.title}
      onClickPrev={onClickPrev}
      classNames={{
        children: cn({ "px-[15px]": isMobileView })
      }}
      buttonProps={{
        onClick: step.next,
        isDisabled: !step.canContinue(questions, index),
        disabled: step.isLoading,
        isLoading: step.isLoading,
      }}
    >
      <form.Field
        name={`questions[${index}].answerId`}
        children={() => {
          // @ts-expect-error here the form type is not exactly compatible but it works
          const props = step.props(form, index);
          return (
            <RadioGroup
              {...props.radioGroup}
              classNames={{ base: "w-full sm:w-[390px]", wrapper: "gap-3" }}
              onValueChange={(v) => {
                props.radioGroup.onValueChange(v);
                if (step.autoForward) {
                  step.resolve();
                }
              }}
            >
              {step.options.map(option => (
                <Radio
                  key={option.id}
                  disabled={step.isLoading}
                  className="overflow-hidden"
                  classNames={{
                    base: "hover:bg-default-200/50 rounded-small max-w-none",
                    label: "text-primary text-[16px] sm:text-[19px] font-display2",
                    wrapper: "h-[18px] w-[18px] bg-content1 border-primary border-1",
                    control: "h-[12px] w-[12px] group-data-[hover=true]:opacity-50 group-data-[hover=true]:scale-50 group-data-[selected=true]:!opacity-100 group-data-[selected=true]:!scale-100",
                  }}
                  value={option.id}>
                  {option.text}
                </Radio>
              ))}
            </RadioGroup>
          );
        }}
      />
    </StepLayout>
  );
}


interface Props {
  step: SQFStepOf<"QNA">;
  form: SQFForm;
  onClickPrev?: () => void;
}
